<template>
    <client-page>
        <sub-visual sh="Contact US" bg="/images/sub/visual/sv6.jpg"> </sub-visual>

        <section class="section section--first">
            <v-container>
                <div class="tit-wrap">
                    <h2 class="tit tit--lg dot-tit">Contact US</h2>
                </div>

                <v-simple-table class="v-simple-table v-data-table--default v-data-table--no-active text-center">
                    <thead>
                        <tr>
                            <th>품목</th>
                            <th>담당자</th>
                            <th>이메일</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td rowspan="2">분석기 패키지 시스템</td>
                            <td class="border-left">이태홍 대표이사</td>
                            <td><a href="mailto:thlee@kiesys.co.kr" class="primary--text text-decoration-underline">thlee@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td class="border-left">오진규 부장</td>
                            <td><a href="mailto:tedd@kiesys.co.kr" class="primary--text text-decoration-underline">tedd@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td>부식 모니터링 시스템</td>
                            <td>정성철 차장</td>
                            <td><a href="mailto:jay@kiesys.co.kr" class="primary--text text-decoration-underline">jay@kiesys.co.kr</a></td>
                        </tr>
                        <tr>
                            <td>파트너십 및 PQ</td>
                            <td>이태홍 대표이사</td>
                            <td><a href="mailto:thlee@kiesys.co.kr" class="primary--text text-decoration-underline">thlee@kiesys.co.kr</a></td>
                        </tr>
                    </tbody>
                </v-simple-table>
            </v-container>
        </section>

        <section class="section section--last pt-0">
            <v-container>
                <div class="tit-wrap">
                    <h3 class="tit top-line-tit">케이아이이 시스템즈에 문의하기</h3>
                </div>

                <!-- <form-input code="contactus" skin="contactus"></form-input> -->
                <form-input skin="contactus"></form-input>
            </v-container>
        </section>
    </client-page>
</template>

<script>
import ClientPage from "@/pages/client/ko/templates/ClientPage.vue";
import SubVisual from "@/components/client/ko/sub/sub-visual.vue";
import FormInput from "@/components/client/ko/form/form-input.vue";
export default {
    components: {
        ClientPage,
        SubVisual,
        FormInput,
    },
};
</script>

<style lang="scss" scoped></style>
